<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>成员管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               :rules="memberUpdateRules"
               label-width="120px"
               class="demo-ruleForm"
               @submit.native.prevent="onSubmit()">
        <el-row class="text item">
          <el-form-item prop="name"
                        label="用户名称:">
            <el-input v-model="form.name"
                      placeholder="请输入用户名称"></el-input>
          </el-form-item>
          <el-form-item prop="password"
                        label="密码:">
            <el-input v-model="form.password"
                      type="password"
                      placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item prop="cellphone"
                        label="手机号:">
            <el-input v-model="form.cellphone"
                      placeholder="请输入手机号"
                      type="number"></el-input>
          </el-form-item>
          <el-form-item prop="mail_address"
                        label="邮箱:">
            <el-input v-model="form.mail_address"
                      placeholder="请输入客户编号"
                      type="email"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-button type="primary"
                     size="mini"
                     native-type="submit"
                     v-if="loading">保存
          </el-button>
          <router-link :to="{ path: '/teke_customer/member/'+form.customerid}">
            <el-button type="primary"
                       size="mini">取消
            </el-button>
          </router-link>
        </el-row>
      </el-form>
    </layout-panel>

  </div>
</template>

<script>
import { memberUpdateRules } from '../tekeCustomer.rules.js'

export default {
  data () {
    return {
      loading: true,
      memberUpdateRules,
      selectLoading: false,
      form: {
        id: this.$route.params.id,
        customerid: null,
        name: null,
        cellphone: null,
        password: '',
        mail_address: null,
        role: null,
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    this.getCustomerDetail()
  },
  methods: {
    ...Vuex.mapActions(['editCustomerMember', 'getTekeCustomerMember']),
    getCustomerDetail () {
      return request.page('getTekeCustomerMember', this.form.id).then(({data}) => {
        filter.setLoop(this.form, data)
        this.form.password = null
      })
    },

    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.form.password && this.form.password.length > 1 && this.form.password.length < 8) {
            this.$message.error('密码至少输入8位！')
            return false
          }
          return request.common('editCustomerMember', this.form).then(({data}) => {
            this.$message({
              showClose: true,
              message: '修改成功',
              type: 'success',
            })
            this.loading = false
          })
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/views/teke-customer/pages/TekeCustomerMemberUpdate.vue